module.exports = __webpack_public_path__ + "static/media/CheckOut.a892ca37.svg";